import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'search-bar',
  styleUrl: 'search-bar.scss',
  shadow: false,
  scoped: true,
  assetsDirs: ['assets']
})
export class SearchBar {
  /**
   * The dev env
   */
  @Prop() env?: string = 'https://www.brighttalk.com';

  render() {
    return (
      <Host>
        <form role="search" class="brighttalk-search-form btalk-component form-search" method='get' action={`${this.env}/search/`} data-bdd='search-form'>
          <div class='search-bar' data-bdd='search-form-label'>
            <input
              type='text'
              name='q'
              placeholder='Search for topics that matter most to your business'
              class='search-bar-input'
              data-bdd='search-form-input'
            />
            <button type='submit' aria-label='Search Button' class='search-bar-button' data-bdd='search-form-submit'>
              <span class="fa-sharp fa-regular fa-magnifying-glass"  aria-hidden="true"></span>
            </button>
          </div>
  		</form>
      </Host>
    );
  }

}
